import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { paths } from '../config/paths';
import { useV2Session } from '../state/SessionProvider';

/**
 * Redirects to /auth when the user is not logged in.
 * Preserves `location` in state so Auth can send them back after sign-in.
 */
export default function RequireAuth({ children }) {
  const { loggedIn } = useV2Session();
  const location = useLocation();

  if (!loggedIn) {
    return <Navigate to={paths.auth} replace state={{ from: location }} />;
  }

  return children;
}
